import ApiService from "@/core/services/api.service";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
const USER = 'userInfo';

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      context.commit(SET_AUTH, credentials);
      // ApiService.post("login", credentials)
      //   .then(({ data }) => {
      //     // ;
      //
      //     resolve(data);
      //   })
      //   .catch(({ response }) => {
      //     context.commit(SET_ERROR, response.data.errors);
      //   });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
          .then(({ data }) => {
            context.commit(SET_AUTH, data);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response.data.errors);
          });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      //  SET AXIOS HEADERS HERE
      ApiService.setHeader();
      ApiService.get("verify")
          .then(({ data }) => {
            context.commit(SET_AUTH, data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response.data.errors);
          });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    //TODO::Write a separate service for the user in the future
    localStorage.setItem(USER, JSON.stringify(user));
    JwtService.saveToken(state.user.token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    window.localStorage.removeItem(USER);
    window.localStorage.removeItem('popup');
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
